/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_details-growth-2': {
    width: 93.156,
    height: 80,
    viewBox: '0 0 93.156 80',
    data: '<path pid="0" d="M24.733 52.203a1.726 1.726 0 00-.626-1.929l-2.836-2.061H0l8.28 11.041a1.723 1.723 0 010 2.07L0 72.365h18.183zm0 0" _fill="#99cf62"/><path pid="1" d="M65.14 53.269a5.175 5.175 0 011.881-5.786l20.818-15.126a1.725 1.725 0 00-1.012-3.121H61.094a5.159 5.159 0 01-4.922-3.577L48.219 1.187a1.725 1.725 0 00-3.278 0L36.988 25.66a5.16 5.16 0 01-4.925 3.577H6.33a1.725 1.725 0 00-1.012 3.121l20.818 15.125a5.175 5.175 0 011.881 5.786l-7.954 24.475a1.725 1.725 0 002.653 1.928l20.819-15.126a5.165 5.165 0 016.087 0L70.44 79.672a1.725 1.725 0 002.653-1.928zm-11.661 5.295" _fill="#99cf62"/><path pid="2" d="M93.156 72.365l-8.28-11.041a1.723 1.723 0 010-2.07l8.28-11.041H71.885l-2.836 2.07a1.725 1.725 0 00-.626 1.928l6.55 20.153zm0 0" _fill="#99cf62"/>'
  }
})
